/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BulkOperation } from './bulkOperation';
import { ErrorResponse } from './errorResponse';


export interface BulkResponse { 
    schemas?: Array<string>;
    operations?: Array<BulkOperation>;
    status?: BulkResponse.StatusEnum;
    errorResponse?: ErrorResponse;
}
export namespace BulkResponse {
    export const StatusEnum = {
        Ok: 'OK',
        Created: 'Created',
        Accepted: 'Accepted',
        NoContent: 'No Content',
        ResetContent: 'Reset Content',
        PartialContent: 'Partial Content',
        MultipleChoices: 'Multiple Choices',
        MovedPermanently: 'Moved Permanently',
        Found: 'Found',
        SeeOther: 'See Other',
        NotModified: 'Not Modified',
        UseProxy: 'Use Proxy',
        TemporaryRedirect: 'Temporary Redirect',
        PermanentRedirect: 'Permanent Redirect',
        BadRequest: 'Bad Request',
        Unauthorized: 'Unauthorized',
        PaymentRequired: 'Payment Required',
        Forbidden: 'Forbidden',
        NotFound: 'Not Found',
        MethodNotAllowed: 'Method Not Allowed',
        NotAcceptable: 'Not Acceptable',
        ProxyAuthenticationRequired: 'Proxy Authentication Required',
        RequestTimeout: 'Request Timeout',
        Conflict: 'Conflict',
        Gone: 'Gone',
        LengthRequired: 'Length Required',
        PreconditionFailed: 'Precondition Failed',
        RequestEntityTooLarge: 'Request Entity Too Large',
        RequestUriTooLong: 'Request-URI Too Long',
        UnsupportedMediaType: 'Unsupported Media Type',
        RequestedRangeNotSatisfiable: 'Requested Range Not Satisfiable',
        ExpectationFailed: 'Expectation Failed',
        PreconditionRequired: 'Precondition Required',
        TooManyRequests: 'Too Many Requests',
        RequestHeaderFieldsTooLarge: 'Request Header Fields Too Large',
        UnavailableForLegalReasons: 'Unavailable For Legal Reasons',
        InternalServerError: 'Internal Server Error',
        NotImplemented: 'Not Implemented',
        BadGateway: 'Bad Gateway',
        ServiceUnavailable: 'Service Unavailable',
        GatewayTimeout: 'Gateway Timeout',
        HttpVersionNotSupported: 'HTTP Version Not Supported',
        NetworkAuthenticationRequired: 'Network Authentication Required'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


